"use strict";

export class DeviceDetector {
    static get TABLET_RATIO() { return 0.65; }

    constructor() {
        this._isIEMobile = navigator.userAgent.indexOf("IEMobile") >= 0;
        this._isIOs = navigator.userAgent.match(/iPhone|iPad|iPod/i) && !this._isIEMobile;
        if (this._isIOs == null) {
            this._isIOs = false;
        }
        this._isIPhone = navigator.userAgent.match(/iPhone/i) && !this._isIEMobile;
        if (this._isIPhone == null) {
            this._isIPhone = false;
        }
        let ua = navigator.userAgent.toLowerCase();
        this._isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
        let width = document.documentElement.clientWidth;
        let height = document.documentElement.clientHeight;
        this._isTablet = (this._isAndroid || this._isIOs) &&
            navigator.userAgent.toLowerCase().indexOf("mobile") == -1 &&
            ((width < height && width / height > DeviceDetector.TABLET_RATIO) ||
            (width > height && height / width > DeviceDetector.TABLET_RATIO));
        this._isDesktop = !this._isIEMobile && !this._isAndroid && !this._isIOs;
        this._isMobile = !this._isDesktop && !this._isTablet;

        this._deviceType = this._isDesktop ? "desktop" : this._isMobile ? "mobile" : "tablet";
    }

    get isIEMobile() {
        return this._isIEMobile;
    }

    get isIOs() {
        return this._isIOs;
    }

    get isAndroid() {
        return this._isAndroid;
    }

    get isDesktop() {
        return this._isDesktop;
    }

    get isMobile() {
        return this._isMobile;
    }

    get isTablet() {
        return this._isTablet;
    }

    get isIPhone() {
        return this._isIPhone;
    }

    get deviceType() {
        return this._deviceType;
    }
}